import styled from 'styled-components/macro';
import { colors } from '../styles/constants';

const Root = styled.div`
    min-height: 100vh;
    width: 100%;
    background: ${colors.backgroundAlt};
    font-size: 14px;
    color: ${colors.text};
    display: flex;
    align-items: flex-start;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export default Root;
